import {createSvgIcon} from '../create-svg-icon';

export const ArrowCircleRightIcon = createSvgIcon(
  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zM4 12c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8-8-3.58-8-8zm12 0-4 4-1.41-1.41L12.17 13H8v-2h4.17l-1.59-1.59L12 8l4 4z" />
, 'ArrowCircleRightOutlined');
